var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from "@i18n";
import Select from "@/components/UiKit/Select/Select";
var QuickFormSection = function QuickFormSection(_ref) {
  var selectedMake = _ref.selectedMake,
    onMakeChange = _ref.onMakeChange,
    onStartProcess = _ref.onStartProcess,
    carMakes = _ref.carMakes;
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("section", {
    className: "my-10 md:my-[71px] px-5 md:px-4 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto relative z-[10] md:max-w-[953px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#f1f6fc] rounded-[16px] p-6 text-center md:p-10 mx-auto md:max-w-full  h-[288px] md:h-[336px] "
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-[28px] font-bold text-[#3c56d4] mb-8 mt-[15px] md:mt-0  md:text-[40px] md:mb-6"
  }, tShort('quick_form/title', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("div", {
    className: "gap-5 justify-center max-w-[556px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 w-full flex flex-col items-start text-start rtl:text-end"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-[16px] font-semibold text-[#555] mb-2"
  }, tShort('quick_form/make_label', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement(Select, {
    name: "make",
    type: "select",
    className: "mb-6 md:mb-6  w-full h-12 border border-[#ddd] rounded-[6px] text-[16px] bg-white transition-colors duration-300 focus:border-[#3c56d4] focus:outline-none ",
    onChange: function onChange(event) {
      return onMakeChange(event.currentTarget.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    selected: true,
    hidden: true
  }, tShort('quick_form/make_placeholder', {
    ns: 'web_sell_trade'
  })), carMakes.map(function (make) {
    return /*#__PURE__*/React.createElement("option", {
      key: make.id,
      value: make.id.toString(),
      selected: selectedMake === make.id.toString()
    }, make.name);
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "max-w-[361px] h-12 bg-[#3c56d4] text-white text-[18px] font-bold border-none rounded-[6px] cursor-pointer transition-all duration-300 ease-in-out mt-5 hover:bg-[#2a45c3] hover:translate-y-[-2px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1)] w-full",
    onClick: onStartProcess,
    "aria-label": tShort('quick_form/start_button', {
      ns: 'web_sell_trade'
    })
  }, tShort('quick_form/start_button', {
    ns: 'web_sell_trade'
  })))))));
};
export default QuickFormSection;